import React, { createContext, useState } from 'react'
import { IEmployee } from '../Models/Employee';

export interface IEmployeeContext {
  employees: IEmployee[], setEmployees: React.Dispatch<React.SetStateAction<IEmployee[]>>,
  resetEmployees:Function,
}

export const EmployeeContext = createContext<IEmployeeContext>({} as IEmployeeContext);


const EmployeeProvider = (props: any) => {

  const [employees, setEmployees] = useState<IEmployee[]>([])
  
  const resetEmployees = (employee : IEmployee) => {
    setEmployees([])
  }

  return (
    <EmployeeContext.Provider
      value={{
        employees,
        setEmployees,
        resetEmployees
      }}>
      {props.children}
    </EmployeeContext.Provider>
  )
}

export default EmployeeProvider
